import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import "react-modern-calendar-datepicker/lib/DatePicker.css"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import AddIcon from "@material-ui/icons/Add"
import FireWarehouseCov from "./FireWarehouseCov";

const styles = (theme) => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    paper: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },
    root: {
        width: "100%",
        margin: "15px",
        padding: "8px",
        direction: "rtl",
    },
    container: {
        maxHeight: 400,
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
})

class ChangePricePet extends Component {
    cookies = new Cookies()
    temp333
    constructor(props) {
        super(props)
        this.state = {
            redirect: false,
            errstr: "",
            errstatus: false,
            okstatus: false,
            requestinfos: [],
            agentInfofilter: [],
            rowsPerPage: 10,
            page: 0,
            pet_price_id: "",
            Firewarehouse_price_buildpercent: "",
            pet_price_annual_premium: "",
            Firewarehouse_price_furniturepercent: "",
            pet_price_deductible: "",
            Firewarehouse_price_disc: "",
            selectedCompany: "",
            selectedPlan: "",
            selectedKind: "",
            selectedTypeofcons: "",
            pet_price_deactivate: "0",
            company_logo_url: "",
            orderBy: "pet_price_id",
            order: "desc",
            snackstr: "",
            showSnack: false,
            snackMode: "success",
            newPriceFireHome: true,
            optionCompany: [],
            optionPlan: [],
            optionKind: [],
            optionTypeofcons: [],
            openDialog: false,
            fireHomeCovarage: [],
            Firewarehouse_price_covarage_percent: "",
            selectedFirehomeCoverage: "",
            pet_price_name: "",
        }
    }

    handleClickOpen = () => {
        this.setState({
            openDialog: true,
        })
    }

    handleClose = () => {
        this.setState({
            openDialog: false,
        })
    }

    handleChangeName = (event) => {
        this.setState({ pet_price_name: event.target.value })
    }
    handleChangeAnnualPremium = (event) => {
        this.setState({ pet_price_annual_premium: event })
    }

    handleChangeDeductible = (event) => {
        this.setState({ pet_price_deductible: event })
    }

    handleChangeCoverageLimit = (event) => {
        this.setState({ pet_price_coverage_limit: event })
    }
    
    handleCompany = (selectedCompany) => {
        this.setState({ selectedCompany: selectedCompany }, () => {
            this.filterPricePet()
        })
    }
    handlePlan = (selectedPlan) => {
        this.setState({ selectedPlan: selectedPlan }, () => {
            this.filterPricePet()
        })
    }

    handleClickcloseTasckBar = (event) => {
        this.setState({ showSnack: false })
    }

// Handler
    handleChangeDeactivate = (event) => {
        const isChecked = event.target.checked; // true = روشن, false = خاموش

        if (isChecked) {
            this.setState({ pet_price_deactivate: "0" }) // روشن → غیرفعال
        } else {
            this.setState({ pet_price_deactivate: "1" }) // خاموش → فعال
        }

        console.log(isChecked)
    }
    
    handleSelectRows = (row2) => {
        this.setState(
            {
                pet_price_id: row2.pet_price_id,
                pet_price_annual_premium: row2.pet_price_annual_premium,
                pet_price_deductible: row2.pet_price_deductible,
                pet_price_coverage_limit: row2.pet_price_coverage_limit,
                pet_price_name: row2.pet_price_name,

                selectedCompany: { value: row2.pet_price_fieldcompany_id, label: row2.company_name, logo: row2.company_logo_url },
                selectedPlan: { value: row2.pet_price_plan_id, label: row2.plan_name, logo: row2.plan_logo_url },

                pet_price_deactivate: row2.pet_price_deactivate,
                company_logo_url: row2.company_logo_url,
                newPriceFireHome: false,
            },
            () => {}
        )
    }

    newPriceFireHome = (event) => {
        this.setState({
            pet_price_id: "",
            pet_price_annual_premium: "",
            pet_price_deductible: "",
            pet_price_coverage_limit: "",
            pet_price_name: "",
            selectedCompany: "",
            selectedPlan: "",
            pet_price_deactivate: "0",
            company_logo_url: "",
            newPriceFireHome: true,
        })
    }
    componentDidMount() {
        if (this.cookies.get("employee_token_str")) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.getoptionCompany()
                        self.getoptionPlan()
                    } else if (arr.result === "error") {
                        self.setState({ redirect: true })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "checkemployeelogin")

            xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ redirect: true })
        }
    }

    deletePetPrice = () => {
        const { pet_price_id } = this.state
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        this.handleClose()
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                    //self.setState({ redirect: true })
                    self.getPricePet()
                    self.newPriceFireHome()
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "delete_pet_price")
        fd.append("pet_price_id", pet_price_id)

        xhttp.open("POST", `${constants.BASE_URL}/Pet`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    getPricePet() {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                        self.filterPricePet()
                    })
                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "get_pet_price")

        xhttp.open("POST", `${constants.BASE_URL}/Pet`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }


    getoptionCompany = () => {
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    var Company = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Company.push({
                            value: arr.data[k].fieldcompany_id,
                            label: arr.data[k].company_name,
                            logo: arr.data[k].company_logo_url,
                        })
                    }
                    self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                        self.getPricePet()
                    })
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "get_fieldcompany")
        fd.append("fieldinsurance", "petsins")
        xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
        xhttp.send(fd)
    }

    getoptionPlan = () => {
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    var Plan = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Plan.push({
                            value: arr.data[k].plan_id,
                            label: arr.data[k].plan_name,
                        })
                    }
                    self.setState({ optionPlan: Plan, selectedPlan: Plan[0] }, () => {
                        self.getPricePet()
                    })
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "get_plan")
        xhttp.open("POST", `${constants.BASE_URL}/Pet`)
        xhttp.send(fd)
    }

    saveNewPricePet = () => {
        const {
            pet_price_annual_premium,
            pet_price_deductible,
            pet_price_coverage_limit,
            pet_price_name,
            selectedCompany,
            selectedPlan,
            pet_price_deactivate,
        } = this.state

        if (
            selectedCompany != "" &&
            selectedPlan != "" &&
            pet_price_annual_premium != "" &&
            pet_price_deductible != "" &&
            pet_price_coverage_limit != "",
            pet_price_name != ""
        ) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        self.getPricePet()
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "add_pet_price")
            fd.append("pet_price_annual_premium", pet_price_annual_premium)
            fd.append("pet_price_deductible", pet_price_deductible)
            fd.append("pet_price_coverage_limit", pet_price_coverage_limit)
            fd.append("pet_price_name", pet_price_name)
            fd.append("pet_price_fieldcompany_id", selectedCompany.value)
            fd.append("pet_price_plan_id", selectedPlan.value)
            fd.append("pet_price_deactivate", pet_price_deactivate)

            xhttp.open("POST", `${constants.BASE_URL}/Pet`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }
    

    ChangePricePet = () => {
        const {
            pet_price_id,
            pet_price_annual_premium,
            pet_price_deductible,
            pet_price_coverage_limit,
            pet_price_name,
            selectedCompany,
            selectedPlan,
            pet_price_deactivate,
        } = this.state
        if (
            selectedCompany != "" &&
            selectedPlan != "" &&
            pet_price_annual_premium != "" &&
            pet_price_deductible != "" &&
            pet_price_coverage_limit != "",
            pet_price_name != ""
        ) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        //self.setState({ redirect: true })
                        self.getPricePet()
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "modify_pet_price")
            fd.append("pet_price_id", pet_price_id)
            fd.append("pet_price_annual_premium", pet_price_annual_premium)
            fd.append("pet_price_deductible", pet_price_deductible)
            fd.append("pet_price_coverage_limit", pet_price_coverage_limit)
            fd.append("pet_price_name", pet_price_name)

            fd.append("pet_price_fieldcompany_id", selectedCompany.value)
            fd.append("pet_price_plan_id", selectedPlan.value)
            fd.append("pet_price_deactivate", pet_price_deactivate)

            xhttp.open("POST", `${constants.BASE_URL}/Pet`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }

    createSortHandler = (field) => {
        if (this.state.orderBy === field) {
            if (this.state.order === "asc") {
                this.setState({ order: "desc" })
            } else {
                this.setState({ order: "asc" })
            }
        } else {
            this.setState({ orderBy: field, order: "asc" })
        }
        var arraytemp = [],
            i,
            j,
            temp,
            a,
            b
        arraytemp = this.state.agentInfofilter
        for (i = 0; i < arraytemp.length; i++) {
            for (j = 0; j < arraytemp.length - 1; j++) {
                a = arraytemp[j]
                b = arraytemp[j + 1]
                if (a[field] < b[field] && this.state.order === "asc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                } else if (a[field] > b[field] && this.state.order === "desc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                }
            }
        }
    }

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
    }

    handleChangePage = (event, number) => {
        this.setState({ page: parseInt(number, 0) })
    }
    filterPricePet = () => {
        const { selectedCompany, requestinfos } = this.state
        var temparray = requestinfos,
            temparray2 = [],
            i
        for (i = 0; i < temparray.length; i++) {
            if ((selectedCompany.value === 0 || temparray[i].pet_price_fieldcompany_id === selectedCompany.value)) {

                temparray2.push(temparray[i])
            }
        }

        this.setState({ agentInfofilter: temparray2 }, () => {})
    }

    render() {
        const { classes } = this.props
        const {
            optionCompany,
            optionPlan,
            snackMode,
            snackstr,
            showSnack,
            newPriceFireHome,
            pet_price_id,
            pet_price_annual_premium,
            pet_price_deductible,
            pet_price_coverage_limit,
            pet_price_name,
            company_logo_url,
            selectedCompany,
            selectedPlan,
            pet_price_deactivate,
            order,
            orderBy,
            okstatus,
            errstr,
            redirect,
            agentInfofilter,
            rowsPerPage,
            page,
        } = this.state
        if (redirect) {
            return <Redirect to="/" />
        } else {
            return (
                <div className={classes.paperrtl} dir="ltr">
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container component="main" maxWidth="lg">
                                <Paper elevation={4} className={classes.root}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <Typography align="center" variant="h7">
                                                {"حیوانات خانگی: " + pet_price_id}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}></Grid>

                                        <Grid item xs={6}>
                                            <div>
                                                <label className="on">شرکت بیمه</label>
                                                <Select
                                                    isSearchable={true}
                                                    className="adapter-txtsize"
                                                    placeholder={"شرکت بیمه"}
                                                    value={selectedCompany}
                                                    onChange={this.handleCompany}
                                                    options={optionCompany}
                                                />
                                            </div>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <div>
                                                <label className="on">طرح ها </label>
                                                <Select
                                                    isSearchable={true}
                                                    className="adapter-txtsize"
                                                    placeholder={"طرح ها"}
                                                    value={selectedPlan}
                                                    onChange={this.handlePlan}
                                                    options={optionPlan}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FloatingLabelInput
                                                placeholder="نام"
                                                handleInputt={this.handleChangeName}
                                                value={pet_price_name}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FloatingLabelInput
                                                type="currency"
                                                placeholder="حق بیمه سالیانه"
                                                handleInputt={this.handleChangeAnnualPremium}
                                                value={pet_price_annual_premium}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FloatingLabelInput
                                                type="percent"
                                                placeholder="فرانشیز"
                                                handleInputt={this.handleChangeDeductible}
                                                value={pet_price_deductible}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FloatingLabelInput
                                                type="currency"
                                                placeholder="سقف تعهد"
                                                handleInputt={this.handleChangeCoverageLimit}
                                                value={pet_price_coverage_limit}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <div style={{ width: "100%", textAlign: "center" }}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={pet_price_deactivate === "0"}  // ✅ "1" = غیرفعال = سوییچ روشن
                                                            onChange={this.handleChangeDeactivate}
                                                            name="gilad"
                                                        />
                                                    }
                                                    label="وضعیت قیمت شرکت بیمه"
                                                />
                                            </div>
                                        </Grid>

                                        <Grid item xs={12}>
                                            {newPriceFireHome ? (
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={this.saveNewPricePet}
                                                >
                                                    {"ثبت قیمت بیمه حیوانات خانگی جدید "}
                                                </Button>
                                            ) : (
                                                <div style={{ width: "100%", textAlign: "right" }}>
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={this.newPriceFireHome}
                                                    >
                                                        {"قیمت بیمه حیوانات خانگی جدید "}
                                                    </Button>
                                                    {"          "}
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={this.ChangePricePet}
                                                    >
                                                        {"ثبت تغییرات"}
                                                    </Button>
                                                    {"          "}
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={(e) => {
                                                            this.handleClickOpen()
                                                        }}
                                                    >
                                                        {" حذف قیمت بیمه حیوانات خانگی"}
                                                    </Button>
                                                </div>
                                            )}
                                        </Grid>

                                        {newPriceFireHome ? null : (
                                            <Grid item xs={12}>
                                                <Divider />
                                            </Grid>
                                        )}
                                    </Grid>
                                </Paper>
                            </Container>
                        </Grid>
                        <Grid item xs={12}>
                            <Container maxWidth="lg">
                                <Paper className={classes.root}>
                                    <TableContainer dir="rtl">
                                        <Table aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        key={"pet_price_id"}
                                                        align={"center"}
                                                        style={{ minWidth: 20 }}
                                                        sortDirection={orderBy === "pet_price_id" ? order : false}
                                                    >
                                                        {" آی دی تخفیف"}
                                                        <TableSortLabel
                                                            active={orderBy === "pet_price_id"}
                                                            direction={orderBy === "pet_price_id" ? order : "asc"}
                                                            onClick={(e) => {
                                                                this.createSortHandler("pet_price_id")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"company_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شرکت بیمه  "}
                                                        <TableSortLabel
                                                            active={orderBy === "company_name"}
                                                            direction={orderBy === "company_name" ? order : "asc"}
                                                            onClick={(e) => {
                                                                this.createSortHandler("company_name")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"plan_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"طرح"}
                                                        <TableSortLabel
                                                            active={orderBy === "plan_name"}
                                                            direction={orderBy === "plan_name" ? order : "asc"}
                                                            onClick={(e) => {
                                                                this.createSortHandler("plan_name")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>


                                                    <TableCell
                                                        key={"pet_price_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نام"}
                                                        <TableSortLabel
                                                            active={orderBy === "pet_price_name"}
                                                            direction={
                                                                orderBy === "pet_price_name"
                                                                    ? order
                                                                    : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("pet_price_name")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"pet_price_annual_premium"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"حق بیمه سالیانه"}
                                                        <TableSortLabel
                                                            active={orderBy === "pet_price_annual_premium"}
                                                            direction={
                                                                orderBy === "pet_price_annual_premium"
                                                                    ? order
                                                                    : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("pet_price_annual_premium")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"pet_price_deductible"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"فرانشیز"}
                                                        <TableSortLabel
                                                            active={orderBy === "pet_price_deductible"}
                                                            direction={
                                                                orderBy === "pet_price_deductible"
                                                                    ? order
                                                                    : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler(
                                                                    "pet_price_deductible"
                                                                )
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"pet_price_coverage_limit"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"سقف تعهد"}
                                                        <TableSortLabel
                                                            active={orderBy === "pet_price_coverage_limit"}
                                                            direction={
                                                                orderBy === "pet_price_coverage_limit" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("pet_price_coverage_limit")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"pet_price_deactivate"}
                                                        align={"center"}
                                                        style={{ minWidth: 20 }}
                                                    >
                                                        {"وضعیت قیمت بیمه حیوانات خانگی"}
                                                        <TableSortLabel
                                                            active={orderBy === "pet_price_deactivate"}
                                                            direction={
                                                                orderBy === "pet_price_deactivate" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("pet_price_deactivate")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {agentInfofilter
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row) => {

                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row["pet_price_id"]}
                                                                value={row}
                                                                onClick={() => {
                                                                    this.handleSelectRows(row)
                                                                }}
                                                            >
                                                                <TableCell key={"pet_price_id"} align={"center"}>
                                                                    {row["pet_price_id"]}
                                                                </TableCell>

                                                                <TableCell key={"company_name"} align={"center"}>
                                                                    {row["company_name"]}
                                                                    <img
                                                                        className={classes.small}
                                                                        alt="Remy Sharp"
                                                                        src={row["company_logo_url"]}
                                                                    />
                                                                </TableCell>
                                                                <TableCell key={"plan_name"} align={"center"}>
                                                                    {row["plan_name"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"pet_price_name"}
                                                                    align={"center"}
                                                                >
                                                                    {row["pet_price_name"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"pet_price_annual_premium"}
                                                                    align={"center"}
                                                                >
                                                                    {row["pet_price_annual_premium"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"pet_price_deductible"}
                                                                    align={"center"}
                                                                >
                                                                    {row["pet_price_deductible"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"pet_price_coverage_limit"}
                                                                    align={"center"}
                                                                >
                                                                    {row["pet_price_coverage_limit"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"pet_price_deactivate"}
                                                                    align={"center"}
                                                                >
                                                                    {row["pet_price_deactivate"] === "1" ||
                                                                    row["pet_price_deactivate"] === 1 ? (
                                                                        <Fab variant="extended">
                                                                            <VoiceOverOffIcon />
                                                                            {"غیر فعال"}
                                                                        </Fab>
                                                                    ) : (
                                                                        <Fab
                                                                            variant="extended"
                                                                            style={{ background: "#44b700" }}
                                                                        >
                                                                            <RecordVoiceOverIcon />
                                                                            {"فعال"}
                                                                        </Fab>
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 100]}
                                        component="div"
                                        count={agentInfofilter.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </Paper>
                            </Container>
                        </Grid>
                    </Grid>

                    {okstatus ? (
                        <Alert severity="success">
                            <AlertTitle>پیام</AlertTitle>
                            {errstr}
                        </Alert>
                    ) : null}
                    <Dialog
                        open={this.state.openDialog}
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه حیوانات خانگی را حذف نمایید"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                انصراف
                            </Button>
                            <Button onClick={this.deletePetPrice} color="primary" autoFocus>
                                بله انجام شود
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )
        }
    }
}

export default withStyles(styles)(ChangePricePet)
